__turbopack_context__.v({
  "button": "style-module-scss-module__uhv5zG__button",
  "buttonContainer": "style-module-scss-module__uhv5zG__buttonContainer",
  "buttonText": "style-module-scss-module__uhv5zG__buttonText",
  "container": "style-module-scss-module__uhv5zG__container",
  "mannequin": "style-module-scss-module__uhv5zG__mannequin",
  "tape": "style-module-scss-module__uhv5zG__tape",
  "text": "style-module-scss-module__uhv5zG__text",
  "textBlock": "style-module-scss-module__uhv5zG__textBlock",
  "title": "style-module-scss-module__uhv5zG__title",
});
